// angular
//     .module('document', [])

/* @ngInject */
export default function ($window) {
    return $window.document;
}



// WEBPACK FOOTER //
// ./src/app/common/angular/globalFactories/documentFactory.js